<template lang="pug">
  div.text-xs.my-2.text-center.text-purple-200.mx-4
    div(v-if="currentIPv4 || currentIPv6")
      div.font-bold.text-purple-100(v-if="currentIPv4") {{currentIPv4}}
      div.font-bold.text-purple-100(v-if="currentIPv6") {{currentIPv6}}
    span(v-else-if="loadingIP") Finding your IP address...
    span(v-else) Unable to find your IP address
</template>
<style lang="postcss" scoped></style>
<script>
export default {
  data() {
    return {
      currentIPv4: "",
      currentIPv6: "",
      loadingIP: false,
      hosts: {
        ipv4: process.env.VUE_APP_IPV4_HOST,
        ipv6: process.env.VUE_APP_IPV6_HOST,
      },
    };
  },
  mounted() {
    this.getAddress("ipv4");
    this.getAddress("ipv6");
  },
  methods: {
    getAddress(type) {
      this.loading = true;
      fetch(`${this.hostFor(type)}/v1/user/ip_address`, {
        method: "GET",
      })
        .then((resp) => {
          this.loading = false;
          if (resp.ok) {
            return resp.json();
          } else {
            console.error("Unable to get IP address");
          }
        })
        .then((json) => {
          if (type === "ipv4") {
            this.currentIPv4 = json.ip_address;
          } else if (type === "ipv6") {
            this.currentIPv6 = json.ip_address;
          }
        });
    },
    hostFor(type) {
      return this.hosts[type];
    },
  },
};
</script>
